import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {FreesSpinIntro} from "../runnerpresentations/FreesSpinIntro";
import {BS2} from "../BS2";
import {LocalPresentation} from "../../core/winpresentation/LocalPresentation";
import {LevelUpgradePresentation} from "../runnerpresentations/maingame/win/LevelUpgradePresentation";
import {FreeSpinUtils} from "../utils/FreeSpinUtils";


/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class BS2SuperFreeSpinIdlePresentation implements FlowStatePresentation {

    constructor() {

    }

    start(flowStateController: FlowStateController): void {
        const presentations = [
            new FreesSpinIntro(),
            new LocalPresentation((controller: SimplePresentationRunnerController) => this.doFreeSpinZeroBet(controller), () => {
                return true
            }, "doFreeSpinZeroBet"),
        ]
        if (BS2.model.isRestoreFeatureBet && !BS2.model.isSuperFreespin() && BS2.model.isNextSuperFreespin()) {
            presentations.unshift(new LevelUpgradePresentation());
        }

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?: Function) => flowStateController.setSkipCallback(callback), "SuperFreespin intro runner ");
    }

    private doFreeSpinZeroBet(controller: SimplePresentationRunnerController) {
        BS2.apiPlugin.betHandler.zeroBet();
        FreeSpinUtils.setKeypadSpinCounter(BS2.model.data.freespinsLeft - 1);
        BS2.reelView.freespinCounter.showCount(BS2.model.data.freespinsLeft - 1);
        controller.finish();
    }


}